{
  "$id": "wealthlane://forms/employee-type/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "employee_type_fields",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/description",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 600,
          "rows": 4
        },
        {
          "scope": "#/properties/isTaxEnable",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 600
        }
      ]
    }
  ]
}
